import axios from "axios";
import { AGO_API_BASE_URL, API_BASE_URL, buildHeaders } from "utils/services";

export const addFreeTransactionsToUser = async (user, user_uuid, free_transactions) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/details/free-transactions/${user_uuid}/`,
      { free_transactions },
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const fetchReduceFees = async (user) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/users/clients/reduced-fees`,
      buildHeaders(user)
    )
    console.log(data)
    return data
  } catch (err) {
    throw err
  }
}

export const reducedUsersFees = async (user, new_fees) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/reduced-fees`,
      new_fees,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const updateUserPriorityFees = async (user, id, body) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/details/priority-margin-fees/${id}`,
      body,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const deleteUserPriorityFees = async (user, id, ticker) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/users/clients/details/priority-margin-fees/${id}?ticker=${ticker}`,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    console.log(err)
    throw err
  }
}

export const reducedMarginFeesToUser = async (user, user_uuid, new_fees) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/details/reduced-margin-fees/${user_uuid}/`,
      new_fees,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const reduceUserOvernightMarginFees = async (user, user_uuid, new_fees) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/details/overnight-fees-discount/${user_uuid}/`,
      new_fees,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const exportPortfolioHistory = async (user, user_uuid, startDate, endDate) => {
  try {
    const params = `?startDate=${startDate}&endDate=${endDate}`
    const { data } = await axios.get(`${API_BASE_URL}/users/clients/${user_uuid}/history-report${params}`,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const updateCertification = async (user, user_uuid, isCertified) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/details/certification/${user_uuid}`,
      { newIsCertified: isCertified },
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const updatePartnerStatus = async (user, user_uuid, isPartner) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/details/partner/${user_uuid}`,
      { newIsPartner: isPartner },
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const updatePartnerPercentages = async (user, user_uuid, percentages) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/details/partner-percentages/${user_uuid}`,
      percentages,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const fetchDeletedUsers = async ({ user, page, limit, alpaca, search, filterType }) => {
  try {
    let params = `?&page=${page}&limit=${limit}&alpaca=${alpaca}${search !== '' ? `&search=${search}` : ''}${filterType !== 'all' ? `&filter=${filterType}` : ''}`
    const { data } = await axios.get(`${API_BASE_URL}/users/clients/deleted/list${params}`,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
};

export const updateUserAppFeatures = async (user, user_uuid, features) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/${user_uuid}/features/update`,
      features,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const notifyUsers = async (user, notification) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/notify`,
      notification,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const closeAccount = async (user, user_uuid, reason) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/${user_uuid}/close-account`,
      { reason },
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const checkCloseAccount = async (user, user_uuid, alpaca_id) => {
  try {
    const { data } = await axios.get(`${AGO_API_BASE_URL}/settings/close/check?user_uuid=${user_uuid}&alpaca_id=${alpaca_id}`,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const setUserReferral = async (user, user_uuid, referral_uuid) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/${user_uuid}/referral`,
      { referral_uuid },
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const deleteUserReferral = async (user, user_uuid) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/users/clients/${user_uuid}/referral`,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const setUserSales = async (user, user_uuid, sales_uuid) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/${user_uuid}/sales`,
      { sales_uuid },
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const deleteUserSales = async (user, user_uuid) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/users/clients/${user_uuid}/sales`,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const offerGoliathsPlusFreeSubscription = async (user, user_uuid, months) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/${user_uuid}/goliaths-plus-free-subscription`,
      { months },
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const updateMarginProviderAccess = async (user, id, new_lmax_access) => {
    try {
        const { data } = await axios.post(`${API_BASE_URL}/users/clients/${id}/margin-provider`, {new_lmax_access},
            buildHeaders(user))
        return data;
    } catch (error) {
        console.error(error)
        throw error
    }
}

export const fetchMutedUsers = async (user, page, limit, search) => {
  let params = `?page=${page}&limit=${limit}${search !== '' ? `&search=${search}` : ''}`
  try {
    const { data } = await axios.get(`${API_BASE_URL}/users/clients/muted/list${params}`, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const unmuteUser = async (user, user_uuid) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/${user_uuid}/unmute`, {}, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}


export const muteUser = async (user, user_uuid) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/${user_uuid}/mute`, {}, buildHeaders(user))
    return data
  } catch (err) {
    throw err
  }
}

export const uploadUserPicture = async ({ user, id, type, picture }) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/${id}/picture`, { type, picture },
      buildHeaders(user)
    )
    return data
  } catch (err) {
    console.error(err)
    throw err
  }
}
export const fetchUserBonuses = async (user, user_uuid) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/users/clients/${user_uuid}/bonuses`,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const grantUserBonus = async (user, user_uuid, bonus) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/${user_uuid}/bonuses`,
      bonus,
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}

export const cancelUserBonus = async (user, user_uuid, bonus_id) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/users/clients/${user_uuid}/bonuses/${bonus_id}/cancel`,
      {},
      buildHeaders(user)
    )
    return data
  } catch (err) {
    throw err
  }
}
